import { EventEmitter, Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Address } from "@app/address/model/address";
import { State } from "@app/root-store/app.state";
import { DataServiceError } from "@app/shared/services/data-service-error";
import { Action, Store, select } from "@ngrx/store";
import { Observable } from "rxjs";
import { AddressActions } from "../actions";
import { AddressSelectors } from "../selectors";

@Injectable({
    providedIn: "root",
})
export class AddressDispatchers {
    dispatchAndSelectAddress(addressId: number): Observable<Address | null> {
        this.store.dispatch(AddressActions.get({ addressId }));
        return this.store.pipe(select(AddressSelectors.getAddress(addressId)));
    }

    upsert(
        form: FormGroup,
        callbackEmitter: EventEmitter<Action>,
        entityId: number,
        address: Address = {} as Address,
        addressType?: string
    ) {
        let action: Action;
        if (!form.invalid) {
            const addressData = { ...address, ...form.value };
            if (addressData.id) {
                action = AddressActions.update({ address: addressData, callbackEmitter });
            } else {
                action = AddressActions.create({ address: addressData, callbackEmitter, addressType, entityId });
            }
            this.store.dispatch(action);
        } else {
            this.store.dispatch(this.upsertFailure(new DataServiceError("Invalid submission", { address })));
        }
    }

    upsertFailure(error: DataServiceError<AddressActions.ActionPayload>) {
        if (error.requestData.address.id) {
            return AddressActions.updateFailure(error);
        }
        return AddressActions.createFailure(error);
    }

    constructor(private readonly store: Store<State>) {}
}
